import axios from "axios";
import {
  SET_LOADER,
  CLEAR_LOADER,
  CLEAR_ERRORS,
  SET_LOADER_SECONDARY,
  GET_VENDOR_USERS_TICKETS,
  GET_SINGLE_VENDOR_USERS_TICKETS,
  GET_VENDOR_DINER_MOBILE,
  GET_VENDOR_DINER_ISSUES_CATEGORY,
  SET_VENDOR_TICKETS_USER_DETAILS,
  GET_ISSUE_SEATING_ADD_TICKET,
  GET_ISSUE_ORDERS_ADD_TICKET,
  GET_ISSUE_OFFERS_ADD_TICKET,
  GET_ISSUE_SCANPAY_ADD_TICKET,
  GET_ISSUE_EVENT_ADD_TICKET,
  GET_ISSUE_WALLET_ADD_TICKET,
  GET_ISSUE_RATINGREVIEW_ADD_TICKET,
  GET_VENDOR_ORDER_ITEM_LIST,
} from "../../types";

import Alert from "react-s-alert";

import { setErrors } from "../../actions/errorActions";
import { serverApi } from "../../../config/Keys";

/***************************************
 * @DESC - ADD VENDOR TICKETS ACTION
 *****************************************/
export const add_vendor_users_tickets =
  (formData, token, callback, onError) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let add_vendor_users_tickets = await axios.post(
        `${serverApi}/vendor/ticket`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (add_vendor_users_tickets.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>Ticket Added Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch(get_vendor_users_tickets(token));
        dispatch({
          type: GET_VENDOR_DINER_MOBILE,
          payload: [],
        });
        dispatch({
          type: SET_VENDOR_TICKETS_USER_DETAILS,
          payload: [],
        });
        callback();
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
      onError(err);
    }
  };

/***************************************
 * @DESC - GET VENDOR TICKETS ACTION
 *****************************************/
export const get_vendor_users_tickets = (token) => async (dispatch) => {
  dispatch({ type: CLEAR_ERRORS });
  dispatch({ type: SET_LOADER });
  try {
    let get_vendor_users_tickets = await axios.get(
      `${serverApi}/vendor/ticket`,
      {
        headers: {
          Authorization: token,
          "Content-Type": "application/json",
        },
      }
    );
    if (get_vendor_users_tickets.data) {
      dispatch({
        type: GET_VENDOR_USERS_TICKETS,
        payload: get_vendor_users_tickets.data,
      });
      dispatch({ type: CLEAR_LOADER });
    }
  } catch (err) {
    console.log(err);
    dispatch({ type: CLEAR_LOADER });
    dispatch(setErrors(err));
  }
};

/***************************************
 * @DESC - GET PERTICULAR DINER TICKET ACTION
 *****************************************/
export const get_vendor_diners_tickets =
  (
    vendorId,
    countryCode,
    mobileNumber,
    token,
    requestName,
    onSuccessLoadUserData
  ) =>
  async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER_SECONDARY });
    try {
      let get_vendor_diners_tickets = await axios.get(
        `${serverApi}/vendor/ticket/${vendorId}?${
          requestName === "phone"
            ? `country_code=${countryCode}&mobile_number=${mobileNumber}`
            : `requestId=${mobileNumber}`
        }`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_vendor_diners_tickets.data) {
        onSuccessLoadUserData(get_vendor_diners_tickets.data);
        dispatch({
          type: GET_VENDOR_DINER_MOBILE,
          payload: get_vendor_diners_tickets.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************************
 * @DESC - GET PERTICULAR ORDER ITEM REQUEST ACTION
 ***************************************************/
export const get_vendor_order_item_list =
  (orderId, token, onSuccessLoadUserData) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_order_items_list = await axios.get(
        `${serverApi}/ordering?order_id=${orderId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_order_items_list.data) {
        onSuccessLoadUserData(get_order_items_list.data);
        dispatch({
          type: GET_VENDOR_ORDER_ITEM_LIST,
          payload: get_order_items_list.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - GET DINER TICKET ISSUES CATEGORY ACTION
 *****************************************/
export const get_vendor_diners_tickets_issue_category =
  (issueTicketId, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_tickets_issue_category = await axios.get(
        `${serverApi}/subcategory?category_id=${issueTicketId}`
      );
      if (get_tickets_issue_category.status === 200) {
        onSuccess();
        dispatch({
          type: GET_VENDOR_DINER_ISSUES_CATEGORY,
          payload: get_tickets_issue_category.data,
        });
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - UPDATE DINER TICKET ACTION
 *****************************************/
export const update_vendor_users_tickets =
  (formData, token, ticketId, onSuccessEditTicket) => async (dispatch) => {
    // console.log(formData, token, ticketId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_vendor_users_tickets = await axios.patch(
        `${serverApi}/vendor/ticket/${ticketId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_vendor_users_tickets.data) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(get_vendor_users_tickets(token));
        Alert.success("<h4>Ticket Edited Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccessEditTicket();
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_vendor_users_tickets_status =
  (
    formData,
    token,
    ticketId,
    onSuccessChangeTicketStatus,
    onErrorChangeTicketStatus,
    handleClose
  ) =>
  async (dispatch) => {
    // console.log(formData, token, ticketId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_vendor_users_tickets = await axios.patch(
        `${serverApi}/vendor/ticket/${ticketId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_vendor_users_tickets.data) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(get_vendor_users_tickets(token));
        Alert.success("<h4>Ticket Edited Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccessChangeTicketStatus(handleClose);
      } else {
        onErrorChangeTicketStatus();
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

export const update_vendor_ticket_desc =
  (formData, token, ticketId, onSuccessEditTicket) => async (dispatch) => {
    // console.log(formData, token, ticketId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let update_vendor_users_tickets = await axios.put(
        `${serverApi}/vendor/ticket/${ticketId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (update_vendor_users_tickets.data) {
        dispatch({ type: CLEAR_LOADER });
        dispatch(get_vendor_users_tickets(token));
        Alert.success("<h4>Ticket Edited Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        onSuccessEditTicket();
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - COMMENT DINER TICKET ACTION
 *****************************************/
export const comment_vendor_users_tickets =
  (formData, token, ticketId, onSuccess) => async (dispatch) => {
    // console.log(formData, token, ticketId);
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let comment_vendor_users_tickets = await axios.patch(
        `${serverApi}/vendor/ticket/${ticketId}`,
        formData,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (comment_vendor_users_tickets.data) {
        dispatch({ type: CLEAR_LOADER });
        Alert.success("<h4>comment Added Successfully</h4>", {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
        dispatch(get_vendor_users_tickets(token));
        onSuccess();
      }
    } catch (err) {
      console.log(err);
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };

/***************************************
 * @DESC - COMMENT DINER TICKET ACTION
 *****************************************/
export const get_vendor_single_users_tickets =
  (ticketId, token, onSuccess) => async (dispatch) => {
    dispatch({ type: CLEAR_ERRORS });
    dispatch({ type: SET_LOADER });
    try {
      let get_vendor_single_users_tickets = await axios.get(
        `${serverApi}/vendor/ticket/${ticketId}`,
        {
          headers: {
            Authorization: token,
            "Content-Type": "application/json",
          },
        }
      );
      if (get_vendor_single_users_tickets.data) {
        dispatch({
          type: GET_SINGLE_VENDOR_USERS_TICKETS,
          payload: get_vendor_single_users_tickets.data,
        });
        onSuccess();
        dispatch({ type: CLEAR_LOADER });
      }
    } catch (err) {
      dispatch({ type: CLEAR_LOADER });
      dispatch(setErrors(err));
    }
  };
